import React, { useEffect, useState } from 'react';
import { withSnackbar } from 'notistack';
import { connect } from 'react-redux';


import InputMask from 'react-input-mask';
import { Button, Select } from 'veloe-ds';
import InputText from '../../Components/Input/index.jsx';

import ScriptTag from 'react-script-tag';
import { useAxisCategory } from './hooks.jsx';

import './placaTag.scss'
import { ValidateForm } from './validator.js';
import { salvarDadosVeiculo } from '../../actions/pedidoActions.js';
import { APP_PAGES } from '../../routes';
import { eventTrackBasic, eventTrackRoute } from '../../utils/pushDataLayer.js';

const DadosVeiculo = ({
    pedido,
    salvarDados,
    history
}) => {
    const {dadosVeiculo} = pedido

    useEffect(() => {
        eventTrackRoute('dados_veiculo');
    }, []);


    const [carDetails, setCarDetails] = useState(dadosVeiculo);
    const [formTouched, setFormTouched] = useState({
        placa: false,
        confirmPlaca: false,
        categoriaVeiculo: true,
        categoriaEixo: true
    });

    const [axisSelected, setAxisSelected] = useState({
        id: "",
        descricao: ""
    });

    const setFormField = (input, value) => {
        setCarDetails(oldValue => ({ ...oldValue, [input]: value }))

        if (!formTouched[input]) {
            setFormTouched(value => ({
                ...value,
                [input]: true
            }))
        }
    }


    const validations = ValidateForm(carDetails, formTouched);
    const {
        data: axis,
        isLoading: axisLoading,
    } = useAxisCategory(carDetails.categoriaVeiculo)

    useEffect(() => {
        if (axis.length) {
            let axisSelected = axis[0]

            if(dadosVeiculo.categoriaEixo !== '' && dadosVeiculo.categoriaVeiculo === carDetails.categoriaVeiculo) {
                axisSelected = axis.find(item => item?.id === dadosVeiculo.categoriaEixo);
            }

            setFormField("categoriaEixo", axisSelected.id)
            setAxisSelected(axisSelected)
        }
    }, [axis, dadosVeiculo.categoriaEixo])

    const onPlacaChanged = (e) => {
        const { name, value } = e.target;
        setFormField(name, value.toUpperCase());
    };

    const submitForm = () => {
        eventTrackBasic('clique:botao', 'continuar-dados_veiculo',carDetails);
        salvarDados(carDetails)
        history.push(APP_PAGES.ONDE_USAR)
    }

    return (
        <div className="containerComponent">
            <div className="containerText">
                <div className="containerLabel">
                    <label className="areaTexto">
                        Sua tag vai ativa e pronta para uso.<br />
                        Preencha as informações do carro que vai usar a tag.
                    </label>
                </div>
            </div>
            <div className="containerArea">
                <div className="containerPlacaTag">

                    <form className="container__form" onSubmit={e => {
                        e.preventDefault();

                        if(!validations) {
                            submitForm();
                        }
                    }}>
                        <InputMask
                            name="placa"
                            mask="aaa9*99"
                            maskChar=""
                            value={carDetails.placa}
                            onChange={e => {
                                onPlacaChanged(e)
                            }}
                            onBlur={() => eventTrackBasic('interacao:campo', 'placa')}
                            disabled={false}
                        >
                            {(inputProps) => (
                                <InputText
                                    {...inputProps}
                                    label="Placa"
                                    placeholder="AAA0000"
                                    error={validations?.placa}
                                    errorMessage={validations?.placa}
                                />
                            )}
                        </InputMask>

                        <InputMask
                            name="confirmPlaca"
                            mask="aaa9*99"
                            maskChar=""
                            value={carDetails.confirmPlaca}
                            onChange={e => onPlacaChanged(e)}
                            onBlur={() => eventTrackBasic('interacao:campo', 'confirmPlaca')}
                            disabled={false}
                        >
                            {(inputProps) => (
                                <InputText
                                    {...inputProps}
                                    label="Confirmar Placa"
                                    placeholder="AAA0000"
                                    error={validations?.confirmPlaca}
                                    errorMessage={validations?.confirmPlaca}
                                />
                            )}
                        </InputMask>

                        <Select
                            label="Selecione o tipo de veículo"
                            values={[
                                "CARRO",
                                "CAMINHAO",
                                "ONIBUS"
                            ]}
                            id="categoria-veiculo"
                            onChange={
                                value => {
                                    setFormField('categoriaVeiculo', value);
                                    eventTrackBasic('interacao:campo', `categoriaVeiculo:${value}`);
                                }
                            }
                            value={carDetails.categoriaVeiculo}
                        />

                        {carDetails.categoriaVeiculo !== 'CARRO' && carDetails.categoriaVeiculo !== '' && !axisLoading &&
                            (<Select
                                label="Selecione o eixo"
                                values={axis.map(item => item?.descricao)}
                                id="eixo-veiculo"
                                onChange={
                                    value => {
                                        const carAxis = axis.find(item => item.descricao === value);
                                        eventTrackBasic('interacao:campo', `categoriaEixo:${value}`);
                                        setAxisSelected(carAxis)
                                        setFormField('categoriaEixo', carAxis?.id)
                                    }
                                }
                                value={axisSelected?.descricao}
                                disabled={axisLoading}
                            />)
                        }

                        <Button
                            {...{
                                onBg: 'light',
                                color: 'primary',
                                disabled: !validations?.isFormValid || axisLoading,
                                label: 'Continuar',
                                id: 'btn-continuar',
                            }}
                            onClick={submitForm}
                        />

                    </form>

                </div>
                <ScriptTag
                    type="text/javascript"
                    src={`https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_KEY_RECAPTCHA}`}
                />
            </div>
        </div>
    );
}


const mapStateToProps = ({ pedido }) => {
    return { pedido };
};

const mapDispatchToProps = (dispatch) => {
    return {
        salvarDados: (onde) => dispatch(salvarDadosVeiculo(onde)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withSnackbar(DadosVeiculo))